import React from 'react'
import Spinner from '../interaxDesignSystemComponents/Spinner'

/**
 * LoadingPage Component
 * Displays a centered loading spinner on a full page
 */
export const LoadingPage: React.FC = () => {
  return <Spinner variant="fullPage" size="large" color="sun" text="Loading..." />
}
